import { Box, Icon, Text } from '@chakra-ui/react';
import icons from 'shared/icons';
import { useTranslation } from 'helpers/languages/translations';
import { backendUrl } from 'config';
import {
    containerStyle,
    diLogoStyle,
    exportButtonStyles,
    messageBoxStyle,
    messageTextStyles,
    titleStyles,
} from './style';

const UnauthorizedAccess = () => {
    const translate = useTranslation();
    const SUPPORT_EMAIL = 'support@dataimpact.io';
    return (
        <Box {...containerStyle}>
            <Icon {...diLogoStyle} as={icons.diLogoFilled} />
            <Box {...messageBoxStyle}>
                <Text {...titleStyles}>
                    {translate('unauthorized.title')}{' '}
                    <Text as="span" fontWeight="bold">
                        <Text as="span" color="yellow.400">
                            {translate('unauthorized.data')}
                        </Text>
                        {translate('unauthorized.impact')}
                    </Text>
                </Text>
                <Text {...messageTextStyles}>
                    {translate('unauthorized.message')}{' '}
                    <Text as="a" href={`mailto:${SUPPORT_EMAIL}`} textDecoration="underline" color="blue.500">
                        {SUPPORT_EMAIL}
                    </Text>
                </Text>
                <Text {...exportButtonStyles} as="a" href={backendUrl('/auth/logout')}>
                    {translate('unauthorized.logout')}
                </Text>
            </Box>
        </Box>
    );
};

export default UnauthorizedAccess;
